import { Component } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { RegTecnicoEntidadAuditoraViewModel } from './entidadauditora.types';
import { EntidadAuditoraService } from './entidadauditora.service';
import { CustomValidator } from '../../../core/_infrastructure/classes/customValidator';
import { DatePipe } from '@angular/common';
import { OnInit } from '@angular/core';
import { UsuarioViewModel } from '../../usuarios/usuarios.types';
import { ConfirmationService } from 'primeng/api';

@Component({
    selector: 'app-tecnicoentidad-edit',
    templateUrl: './tecnicoentidad-edit.component.html',
})
export class TecnicoEntidadEditComponent extends ComponentBase implements OnInit {
    /** nombrescientificos-edit ctor */

    editMode: boolean;
    editTitle = 'Nuevo';
    usuarioTecnicoEA: UsuarioViewModel;
    visibilitySpinner = false;
    isCollapsedEntidad = false;
    IdEntidadAuditora: number;

    constructor(
        public datepipe: DatePipe,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: UntypedFormBuilder,
        protected notificationService: NotificationService,
        private entidadAuditoraService: EntidadAuditoraService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private confirmationService: ConfirmationService,
    ) {
        super(authService, notificationService, exceptionHandler);

        //this.tecnico = new RegTecnicoEntidadAuditoraViewModel();
        this.usuarioTecnicoEA = new UsuarioViewModel();
        this.usuarioTecnicoEA.TwRegTecnicoEntidadAuditora = new RegTecnicoEntidadAuditoraViewModel();
    }

    ngOnInit() {
        this.createForm();

        let idEntidad = +this.activatedRoute.snapshot.params['id'];
        let idTecnico = +this.activatedRoute.snapshot.params['idTecnico'];

        this.IdEntidadAuditora = idEntidad;
        //EDIT
        if (idTecnico) {
            this.editMode = true;
            this.editTitle = 'Editar';

            this.entidadAuditoraService.getTecnico(idTecnico).subscribe(result => {
                this.usuarioTecnicoEA = result;
                this.updateForm();
            });

            //En edicion se deshabilita para no poder modificarlo
            this.form.controls['Nif'].disable();
            this.form.controls['Activo'].disable();
        }
        //ALTA
        else {
            //En el alta se graba activa por defecto
            this.form.controls['Activo'].disable();
        }
    }

    createForm() {
        this.form = this.fb.group({
            Nombre: ['', Validators.required],
            Apellidos: ['', Validators.required],
            Nif: ['', Validators.compose([Validators.required, CustomValidator.NIFValidator])],
            Ropo: ['', Validators.required],
            Telefono: ['', Validators.required],
            Email: ['', Validators.compose([Validators.required, CustomValidator.emailEmptyValidator])],
            Activo: true,
            FechaAlta: [{ value: '', disabled: true }],
            FechaBaja: [{ value: '', disabled: true }],
            FechaCreacion: '',
        });
    }

    updateForm() {
        this.form.setValue({
            Nombre: this.usuarioTecnicoEA.Nombre,
            Apellidos: this.usuarioTecnicoEA.Apellidos,
            Nif: this.usuarioTecnicoEA.Nif,
            Telefono: this.usuarioTecnicoEA.TwRegTecnicoEntidadAuditora.Telefono,
            Email: this.usuarioTecnicoEA.Email,
            Ropo: this.usuarioTecnicoEA.TwRegTecnicoEntidadAuditora.Ropo,
            Activo: this.usuarioTecnicoEA.TwRegTecnicoEntidadAuditora.Activo,
            FechaAlta: new Date(this.usuarioTecnicoEA.TwRegTecnicoEntidadAuditora.FechaAlta),
            FechaBaja:
                this.usuarioTecnicoEA.TwRegTecnicoEntidadAuditora.FechaBaja != null
                    ? new Date(this.usuarioTecnicoEA.TwRegTecnicoEntidadAuditora.FechaBaja)
                    : '',
            FechaCreacion: new Date(this.usuarioTecnicoEA.FechaCreacion),
        });
    }

    onSubmit() {
        this.submitted = true;

        if (!this.form.valid) {
            this.addErrorMessage('Revise los datos');
            this.isCollapsedEntidad = false;
            return;
        }

        this.visibilitySpinner = true;

        let usuarioTecnicoEA = new UsuarioViewModel();
        usuarioTecnicoEA.TwRegTecnicoEntidadAuditora = new RegTecnicoEntidadAuditoraViewModel();

        usuarioTecnicoEA.Nombre = this.form.value.Nombre;
        usuarioTecnicoEA.Apellidos = this.form.value.Apellidos;
        usuarioTecnicoEA.Nif = this.form.value.Nif != null ? this.form.value.Nif : this.usuarioTecnicoEA.Nif;
        usuarioTecnicoEA.Email = this.form.value.Email != null ? this.form.value.Email : this.usuarioTecnicoEA.Email;
        usuarioTecnicoEA.TwRegTecnicoEntidadAuditora.Telefono = this.form.value.Telefono;
        usuarioTecnicoEA.TwRegTecnicoEntidadAuditora.Ropo = this.form.value.Ropo;
        usuarioTecnicoEA.TwRegTecnicoEntidadAuditora.Activo = this.usuarioTecnicoEA.TwRegTecnicoEntidadAuditora.Activo;
        usuarioTecnicoEA.TwRegTecnicoEntidadAuditora.IdRegEntidadAuditora = this.IdEntidadAuditora;
        usuarioTecnicoEA.Id = this.usuarioTecnicoEA.Id;
        //PERFILES
        usuarioTecnicoEA.TUsuarioPerfilCollection = this.usuarioTecnicoEA.TUsuarioPerfilCollection;

        if (this.editMode) {
            usuarioTecnicoEA.FechaCreacion = this.usuarioTecnicoEA.FechaCreacion;
        }

        if (this.editMode) {
            this.entidadAuditoraService.editTecnico(usuarioTecnicoEA).subscribe({
                next: () => {
                    this.addSuccessMessage('Técnico autorizado modificado correctamente');
                    this.visibilitySpinner = false;
                    this.isCollapsedEntidad = false;
                    this.onBack();
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                    this.isCollapsedEntidad = false;
                },
            });
        } else {
            this.entidadAuditoraService.getSiUsuarioExisteComoAC(usuarioTecnicoEA).subscribe({
                next: res => {
                    if (res == true) {
                        this.confirmationService.confirm({
                            message:
                                'El usuario técnico de Entidad Auditora que intenta añadir ya está dado de alta como usuario Agente de Control, ¿quiere asignarle el perfil de Entidad Auditora también?',
                            accept: () => {
                                this.entidadAuditoraService.addTecnicoExistenteComoACyEA(usuarioTecnicoEA).subscribe({
                                    next: () => {
                                        this.addSuccessMessage('Técnico autorizado añadido correctamente');
                                        this.visibilitySpinner = false;
                                        this.isCollapsedEntidad = false;
                                        window.location.reload();
                                    },
                                    error: error => {
                                        this.catchServerError(error);
                                        this.visibilitySpinner = false;
                                        this.isCollapsedEntidad = false;
                                    },
                                });
                            },
                            reject: () => {
                                this.visibilitySpinner = false;
                                return;
                            },
                        });
                    } else {
                        this.entidadAuditoraService.addTecnico(usuarioTecnicoEA).subscribe({
                            next: () => {
                                this.addSuccessMessage('Técnico autorizado añadido correctamente');
                                this.visibilitySpinner = false;
                                this.isCollapsedEntidad = false;
                                window.location.reload();
                            },
                            error: error => {
                                this.catchServerError(error);
                                this.visibilitySpinner = false;
                                this.isCollapsedEntidad = false;
                            },
                        });
                    }
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                    this.isCollapsedEntidad = false;
                },
            });
        }
    }

    onBack() {
        this.router.navigate(['/mantenimiento/registros/entidadesauditoras/edit', this.IdEntidadAuditora]);
    }
}
